<template>
  <equipment-orders-card
      v-if="member && member.id"
      :organization-id="organizationId"
      :title="$t('onboarding.commissioning.member.title')"
      :query="query"
      :matches="isOfMember"
      holder="member"
      :member="member"
      hide-beneficiary
      v-bind="$attrs"
      v-on="$listeners"
  />
</template>

<script>
import EquipmentOrdersCard from './EquipmentOrdersCard.vue'

/**
 * Sur la fiche d'un membre : ses commandes d'équipement (borne, compteur, véhicule, badges…) et le
 * bouton pour en passer une pour lui. La recherche par e-mail resserre la liste ; seul le membre fait foi.
 */
export default {
  name: 'MemberEquipmentOrders',

  components: { EquipmentOrdersCard },

  props: {
    member: { type: Object, required: true },
  },

  computed: {
    organizationId() {
      return this.member?.organization?.id || null
    },
    query() {
      return { holder: 'member', search: this.member?.customer?.email || null }
    },
  },

  methods: {
    isOfMember(order) {
      return order.memberId === this.member.id
    },
  },
}
</script>
